import { Box, Center } from '@mantine/core';
import { PropsWithChildren } from 'react';

export default function FillAndCenter({ children }: PropsWithChildren<object>) {
	return (
		<Box style={{ position: 'absolute', inset: 0 }}>
			<Center h={'100%'}>{children}</Center>
		</Box>
	);
}
